import { useMemo } from 'react';

import { resolveCaregiverEhrLink } from '@apps/web/lib/data_source_utils';
import {
    useOrganizationCaregiver,
    useOrganizationDataSourceAccounts,
} from '@apps/web/swr_data_fetching/data_fetching_hooks';

// Same caregiver EHR deep-link as production `/conversations`: AxisCare
// (`/?caregivers-profile.php&id=`), WellSky, etc. Opens in a new tab.
export function useInboxCaregiverEhrLink(
    organizationId: string | null,
    caregiverId: string | null,
): { readonly href: string; readonly label: string } | null {
    const { data: caregiver } = useOrganizationCaregiver(
        caregiverId ? organizationId : null,
        caregiverId,
        { reason: 'conversations-inbox-ehr-link' },
    );
    const { data: dataSourceAccounts } = useOrganizationDataSourceAccounts(
        caregiverId ? organizationId : null,
        { reason: 'conversations-inbox-ehr-link' },
    );
    return useMemo(
        () => resolveCaregiverEhrLink(caregiver, dataSourceAccounts),
        [caregiver, dataSourceAccounts],
    );
}
